import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';
import { isEqual } from 'lodash';
import { converterValorByTaxa } from '@/utils/conversao-moeda-utils';

function getSavingProduto(quantidadeOriginal, savingOriginal, novaQuantidade) {
  if (isEqual(novaQuantidade, quantidadeOriginal)) {
    return savingOriginal;
  }
  return currency(savingOriginal, { precision: DEFAULT_PRECISION })
    .divide(currency(quantidadeOriginal, { precision: DEFAULT_PRECISION }))
    .multiply(currency(novaQuantidade, { precision: DEFAULT_PRECISION })).value;
}

function calcularSaving(produtos) {
  return produtos
    .map(produto => getSavingProduto(
      produto.$$quantidadeOriginal,
      produto.saving,
      produto.quantidade,
    ))
    .reduce((a, b) => currency(a, { precision: DEFAULT_PRECISION })
      .add(currency(b, { precision: DEFAULT_PRECISION })).value, 0);
}

export function calcularSavingFinalizacao(produtos, taxaVenda) {
  const saving = calcularSaving(produtos);
  return {
    saving,
    savingConvertido: converterValorByTaxa(saving, taxaVenda),
  };
}

export default {
  calcularSavingFinalizacao,
};
